import React from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';
import { ReactComponent as RightTickDisableSvg } from 'assets/rightTickDisable.svg';

const RightTickDisableIcon: React.FC<SvgIconProps> = (props) => {
  return <SvgIcon {...props} component={RightTickDisableSvg} />;
};

export default RightTickDisableIcon;
